<p class="text-center mb-4"><i class="pi pi-envelope" style="font-size: 3rem"></i></p>
<h5 class="title-h5 text-center mb-16">{{ "public_newpassword_title" | translate }}</h5>
<div class="text-center">
    @if (userActivated) {
        <p class="text-center" style="font-size: 1.2rem">
            {{ "public_newpassword_passwordsent" | translate }}<br />
            {{ "public_newpassword_passwordsent2" | translate }}
        </p>
        <button pButton type="button" class="mt-16 body-button p-button-blue-logo" (click)="goToLogin()">{{ "standard_login" | translate }}</button>
    }
    @if (tokenExpired) {
        <p class="text-center">{{ "public_newpassword_error_outdated" | translate }}</p>
        <button pButton type="button" class="mt-16 body-button p-button-blue-logo" (click)="goToRequest()">
            {{ "public_newpassword_buttonagain" | translate }}
        </button>
    }
</div>
